import React from "react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "../ui/dialog";

import { RootState } from "@/store/store";
import { useDispatch, useSelector } from "react-redux";
import { closeDialog } from "@/store/reducers/dialogReducer";
import { Button } from "../ui/button";
import DialogLoaderButton from "../loader-button/DialogLoaderButton";
import { DialogType } from "@/enums/dialogs";

interface RequestReturnCrationDialogProps {
  handleValidate: () => void;
}

const RequestReturnCrationDialog: React.FC<RequestReturnCrationDialogProps> = ({
  handleValidate,
}) => {
  const dispatch = useDispatch();
  const { isOpen, dialogType } = useSelector(
    (state: RootState) => state.dialog
  );
  const isOpened =
    isOpen && dialogType === DialogType.REQUEST_RETURN_CREATE_DIALOG;

  const handleClose = () => {
    dispatch(closeDialog());
  };

  return (
    <Dialog open={isOpened} onOpenChange={handleClose}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Confirmation</DialogTitle>
          <DialogDescription>
            Étes-vous sûr de vouloir créer ce retour ?
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="flex flex-col sm:flex-row gap-2 sm:gap-0">
          <Button variant="outline" className="mr-2" onClick={handleClose}>
            Annuler
          </Button>
          <DialogLoaderButton
            name="Confirmer"
            handleSubmit={handleValidate}
            isLoading={false}
          />
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default RequestReturnCrationDialog;
